import { render, staticRenderFns } from "./comBtn.vue?vue&type=template&id=5bb58459&scoped=true&"
import script from "./comBtn.vue?vue&type=script&lang=js&"
export * from "./comBtn.vue?vue&type=script&lang=js&"
import style0 from "./comBtn.vue?vue&type=style&index=0&id=5bb58459&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb58459",
  null
  
)

export default component.exports